import type { PivotRow, SortDir } from "./types"

/** Sort keys that are not period columns. */
export const NAME_SORT = "name"
export const TOTAL_SORT = "total"

export interface SortState {
  sort: string | null
  dir: SortDir
}

/** Names read A→Z first; numbers read biggest first. */
export function firstDir(key: string): SortDir {
  return key === NAME_SORT ? "asc" : "desc"
}

/** Clicking a header cycles: first direction → other direction → no sort. */
export function nextSort(current: SortState, key: string): SortState {
  const first = firstDir(key)
  if (current.sort !== key) return { sort: key, dir: first }
  if (current.dir === first) return { sort: key, dir: first === "asc" ? "desc" : "asc" }
  return { sort: null, dir: "desc" }
}

/** Reorders whole rows by one column's revenue (or by name). No sort → input order. */
export function sortRows<T extends { row: PivotRow }>(items: T[], { sort, dir }: SortState): T[] {
  if (!sort) return items
  const sign = dir === "asc" ? 1 : -1
  if (sort === NAME_SORT) {
    return [...items].sort((a, b) => sign * a.row.label.localeCompare(b.row.label, "en"))
  }
  const value = (r: PivotRow) => (sort === TOTAL_SORT ? r.total.revenue : (r.cells[sort]?.revenue ?? 0))
  return [...items].sort((a, b) => sign * (value(a.row) - value(b.row)))
}
